/*
 * Copyright (c) 2021.
 * Md Naimul Hasan
 * naim886@gmail.com
 * 01719123886
 * www.naimbd.com
 */
import React, {useEffect, useState} from "react";
import axios from "axios";
import BASEURL from './../../../Constants'
import {Link} from "react-router-dom";
import Pagination from "react-js-pagination";
import loader from './../../../Assets/image/loader/ripple.svg'
import {Modal} from "react-bootstrap";
import Select from "react-select";
import {toast, ToastContainer} from "react-toastify";


const AppointmentList = () => {

    const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
    const [isPriceUpdateModalOpen, setPriceUpdateModalOpen] = useState(false);
    const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);

    const [statusSelect, setStatusSelect] = useState({})
    const [status, setStatus] = useState({})
    const handleStatusUpdateModal = (id) => {
        setStatus(prev => ({...prev, appointment_id: id}))
        setIsStatusModalOpen(true)
    }
    const updateStatus = () => {
      axios.post(BASEURL+'/api/dashboard/update-status', status).then(res=>{
          toast.success(res.data.msg)
          setErrMsg([])
          setIsStatusModalOpen(false)
          getAppointments()
      }).catch(function (errors) {
          if (errors.response.status == 422) {
              setErrMsg([])
              setErrMsg(errors.response.data.errors)
          }
      })
    }
    const handleStatusSelect = (selectedOption, e) => {
        setStatus(prev => ({...prev, status: selectedOption.value}))
    }

    const getStatus = () => {
        axios.get(BASEURL + '/api/dashboard/get-status-for-select').then(res => {
            setStatusSelect(res.data)
        })
    }
    const [amountInput, setAmountInput] = useState({})
    const handlePriceUpdateModal = (id, price) => {
        setAmountInput(prev => ({...prev, appointment_id: id}))
        setAmountInput(prev => ({...prev, amount: price}))
        setPriceUpdateModalOpen(true)
    }
    const updateAmount = () => {
        axios.post(BASEURL + '/api/dashboard/update-order-price', amountInput).then(res => {
            toast.success(res.data.msg)
            setPriceUpdateModalOpen(false)
            setErrMsg([])
            getAppointments()
        }).catch(function (errors) {
            if (errors.response.status == 422) {
                setErrMsg([])
                setErrMsg(errors.response.data.errors)
            }
        })
    }
    const handleAmountInput = (e) => {
        setAmountInput(prev => ({...prev, amount: e.target.value}))
    }
    const handleAssignModal = (id) => {
        getUserPreferredTime(id)
        setIsAssignModalOpen(true)
        setInput(prev => ({...prev, appointment_id: id}))
    }
    const [activePage, setActivePage] = useState(1)
    const [itemsCountPerPage, setItemsCountPerPage] = useState(0)
    const [totalItemsCount, setTotalItemsCount] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [appointment, setAppointment] = useState([])
    const getAppointments = (pageNumber) => {
        setActivePage(pageNumber)
        setIsLoading(true)
        axios.post(BASEURL + '/api/dashboard/get-appointment?page=' + pageNumber, date).then(res => {
            setAppointment(res.data.data)
            setItemsCountPerPage(parseInt(res.data.meta.per_page))
            setTotalItemsCount(res.data.meta.total)
            setActivePage(res.data.meta.current_page)
            setIsLoading(false)
        })
    }
    const [truckList, setTruckList] = useState([])
    const getTruckList = () => {
        axios.get(BASEURL + '/api/dashboard/get_truck_list_for_select').then(res => {
            setTruckList(res.data)
        })
    }
    const [shift, setShift] = useState([])
    const getShifts = () => {
        axios.get(BASEURL + '/api/dashboard/get-shift-for-select').then(res => {
            setShift(res.data)
        })
    }
    const [input, setInput] = useState({})
    const handleSelect = (selectedOption, e) => {
        setInput(prev => ({...prev, [e.name]: selectedOption.value}))
    }
    const handleInput = (e) => {
        setInput(prev => ({...prev, [e.target.name]: e.target.value}))
    }
    const [userPreferredTime, setUserPreferredTime] = useState('')
    const getUserPreferredTime = (id) => {
        axios.get(BASEURL + '/api/dashboard/get-user-preferred-time/' + id).then(res => {
            setUserPreferredTime(res.data)
        })
    }
    const [errMsg, setErrMsg] = useState([])
    const setSchedule = () => {
        axios.post(BASEURL + '/api/dashboard/schedule', input).then(res => {
            setErrMsg([])
            if (res.data.msg == 'Truck Already Scheduled') {
                toast.warn(res.data.msg);
            } else {
                setIsAssignModalOpen(false)
                toast.success(res.data.msg);
                getAppointments()
            }
        }).catch(function (errors) {
            if (errors.response.status == 422) {
                setErrMsg([])
                setErrMsg(errors.response.data.errors)
            }
        })
    }
    useEffect(() => {
        getAppointments()
        getTruckList()
        getShifts()
        getStatus()
    }, []);

    const [date, setDate] = useState([])
    const handleDateInput = (e) => {
        setDate(prev =>({...prev, [e.target.name] :e.target.value }))
    }
    const handleSearch = () => {
        setDate(prev =>({...prev, time: 'between' }))
        getAppointments()
    }
    const handleButtonInput = (e, time) => {
        if (time == 'all'){
            setDate(prev =>({...prev, time: 'all' }))
        }else if(time=='this'){
            setDate(prev =>({...prev, time: 'this' }))
        }else if(time=='prev'){
            setDate(prev =>({...prev, time: 'prev' }))
        }
    }

    useEffect(()=>{
        getAppointments()
    }, [date.time])

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <main>
                <div className="container-fluid px-4">
                    <h1 className="mt-4">Appointment</h1>
                    <ol className="breadcrumb mb-4">
                        <li className="breadcrumb-item"><Link to={'/'}>Dashboard</Link></li>
                        <li className="breadcrumb-item active">Appointment List</li>
                    </ol>
                    <div className="row">
                        <div className="col-md-6 text-start mb-1">
                            <button onClick={(e)=>handleButtonInput(e, 'all')} className={'btn btn-success btn-sm'}>All Time</button>
                            <button onClick={(e)=>handleButtonInput(e, 'this')} className={'btn btn-success btn-sm ms-1'}>Today</button>
                            <button onClick={(e)=>handleButtonInput(e, 'prev')} className={'btn btn-success btn-sm ms-1'}>Yesterday</button>
                        </div>
                        <div className="col-md-6 text-end mb-1">
                            <div className="row align-items-center">
                                <div className="col-5">
                                    <input
                                        type={'date'}
                                        className={'form-control form-control-sm'}
                                        name={'start_date'}
                                        onChange={handleDateInput}
                                    />
                                </div>
                                <div className="col-5">
                                    <input
                                        type={'date'}
                                        className={'form-control form-control-sm'}
                                        name={'end_date'}
                                        onChange={handleDateInput}
                                    />
                                </div>
                                <div className="col-2">
                                    <button onClick={handleSearch} className={'btn btn-success btn-sm ms-1'}>Search</button>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="my-card">
                                <table className={'table table-hover table-bordered'}>
                                    <thead>
                                    <tr>
                                        <th>SL</th>
                                        <th>Customer</th>
                                        <th>Order No</th>
                                        <th>Service</th>
                                        <th>Time</th>
                                        <th>Address</th>
                                        <th>Schedule</th>
                                        <th>Amount</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {appointment.map((item, index) => (
                                        <tr key={index}>
                                            <td className={'align-middle'}>{index + 1}</td>
                                            <td className={'align-middle'}>{item.user.name}<br/><small
                                                className={'text-success'}>{item.user.email}<br/></small><small
                                                className={'text-info'}>{item.user.phone}</small></td>
                                            <td className={'align-middle'}>{item.id}</td>
                                            <td className={'align-middle'}>{item.service_type} <br/><small
                                                className={'text-success'}>{item.type}</small><br/><small
                                                className={'text-info'}>{item.size}</small> <br/><small
                                                className={'text-warning'}>{item.distance}</small></td>
                                            <td className={'align-middle'}><span
                                                className={'text-success'}>Preferred Schedule Time: <br/>{item.date_time}</span><br/><span
                                                className={'text-info'}>Order Place Time <br/>{item.created_at}</span>
                                            </td>
                                            <td className={'align-middle'}>{item.company}<br/>Address: {item.address}<br/> City: {item.city} {item.zip}
                                            </td>
                                            <td className={'align-middle'}>
                                                {item.schedule != null ?
                                                    <span>
                                                        <span
                                                            className={'text-success'}>Date & Time:<br/> {item.schedule != null ? item.schedule.schedule_time : ' Not Set Yet'}</span>
                                                        <hr/>
                                                        <span
                                                            className={'text-info'}>Truck: {item.schedule != null ? item.schedule.truck : ' Not Set Yet'}</span>
                                                        <hr/>
                                                        <span
                                                            className={'text-success'}>Shift: {item.schedule != null ? item.schedule.shift : ' Not Set Yet'}</span>
                                                    </span>
                                                    : 'Not Set Yet'
                                                }

                                            </td>
                                            <td className={'align-middle'}>
                                                <span>{item.amount != null && item.amount != 0 ? '$ ' + item.amount : 'Will Update'}</span>
                                                <br/>
                                                <small
                                                    dangerouslySetInnerHTML={{__html: item.payment_status == 'COMPLETED' ? '<span class="text-success">Paid</span>' : '<span class="text-danger">Unpaid</span>'}}/>
                                            </td>
                                            <td className={'align-middle'}>
                                                <small>{item.status}</small></td>
                                            <td className={'align-middle'}>
                                                <Link to={'/appointment/details/' + item.id}>
                                                    <button className={'btn btn-sm btn-info'}><i
                                                        className={'fas fa-eye'}/>
                                                    </button>
                                                </Link>
                                                {/*<Link to={`/client/appointment-edit/${item.id}`}>*/}
                                                {/*    <button className={'btn btn-sm btn-warning ms-1'}><i*/}
                                                {/*        className={'fas fa-edit'}/></button>*/}
                                                {/*</Link> */}
                                                <br/>
                                                <button onClick={() => handleAssignModal(item.id)}
                                                        className={'btn btn-success btn-sm mt-1'}><i
                                                    className="far fa-check-square"/> Assign
                                                </button>
                                                {item.payment_status != 'COMPLETED' ?
                                                    <button className={'btn btn-success btn-sm mt-1'}
                                                            onClick={() => handlePriceUpdateModal(item.id, item.amount)}>
                                                        <i
                                                            className="fas fa-dollar-sign"/> Update Price
                                                    </button> : null
                                                }
                                                <button className={'btn btn-info btn-sm mt-1'}
                                                        onClick={()=>handleStatusUpdateModal(item.id)}><i
                                                    className="fas fa-toggle-off"/> Update Status
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                                {isLoading ?
                                    <div className="loader">
                                        <img src={loader} alt={'Loader'}/>
                                    </div> : null
                                }
                                {totalItemsCount > 20 ?
                                    <nav aria-label="Page navigation example">
                                        <Pagination
                                            activePage={activePage}
                                            itemsCountPerPage={itemsCountPerPage}
                                            totalItemsCount={totalItemsCount}
                                            // pageRangeDisplayed={5}
                                            onChange={getAppointments}
                                            nextPageText="Next"
                                            prevPageText="Previous"
                                            firstPageText="First"
                                            lastPageText="Last"
                                            itemClass="page-item"
                                            linkClass="page-link"
                                        />
                                    </nav> : null
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <Modal
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={isAssignModalOpen}
                    onHide={() => setIsAssignModalOpen(false)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            <span>Assign Order</span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-md-12">
                                <h5 className={'text-success mb-3'}>User Preferred Time : {userPreferredTime}</h5>
                            </div>
                            <div className="col-md-6 my-2">
                                <label>
                                    Select Truck
                                    <Select
                                        options={truckList}
                                        placeholder={'Select Option'}
                                        onChange={handleSelect}
                                        name={'truck_id'}
                                    />
                                    {Object.entries(errMsg).map(([key, val]) => (
                                        <small
                                            className="text-danger validation-error-message"
                                            key={key}>{key == 'truck_id' ? val : ''}
                                        </small>
                                    ))}
                                </label>
                            </div>
                            <div className="col-md-6 my-2">
                                <label>
                                    Select Shift
                                    <Select
                                        options={shift}
                                        placeholder={'Select Option'}
                                        onChange={handleSelect}
                                        name={'shift_id'}
                                    />
                                    {Object.entries(errMsg).map(([key, val]) => (
                                        <small
                                            className="text-danger validation-error-message"
                                            key={key}>{key == 'shift_id' ? val : ''}
                                        </small>
                                    ))}
                                </label>
                            </div>
                            <div className="col-md-12 my-2">
                                <label>
                                    Select Date Time
                                    <input
                                        placeholder={'Select Time and Date'}
                                        onChange={handleInput}
                                        name={'schedule_time'}
                                        type={'datetime-local'}
                                        className={'form-control'}
                                    />
                                    {Object.entries(errMsg).map(([key, val]) => (
                                        <small
                                            className="text-danger validation-error-message"
                                            key={key}>{key == 'schedule_time' ? val : ''}
                                        </small>
                                    ))}
                                </label>
                            </div>
                            <div className="col-md-12 my-2">
                                <div className="d-grid">
                                    <button className={'btn btn-success'} onClick={setSchedule}>Assign Truck and Time
                                    </button>
                                </div>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>

                <Modal
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={isPriceUpdateModalOpen}
                    onHide={() => setPriceUpdateModalOpen(false)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            <span>Update Or Set Price</span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row justify-content-center">
                            <div className="col-md-7 my-2">
                                <label className={'mb-2'}>Inset Price </label>
                                <div className="input-group">
                                    <span className={'input-group-text'}>$</span>
                                    <input
                                        placeholder={'Enter Updated Price'}
                                        onChange={handleAmountInput}
                                        name={'amount'}
                                        type={'number'}
                                        className={'form-control'}
                                        defaultValue={amountInput.amount}
                                    />
                                </div>
                                {Object.entries(errMsg).map(([key, val]) => (
                                    <small
                                        className="text-danger validation-error-message"
                                        key={key}>{key == 'amount' ? val : ''}
                                    </small>
                                ))}

                            </div>
                            <div className="col-md-7 my-2">
                                <div className="d-grid">
                                    <button className={'btn btn-success'} onClick={updateAmount}>Update Price</button>
                                </div>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>

                <Modal
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={isStatusModalOpen}
                    onHide={() => setIsStatusModalOpen(false)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            <span>Update Status</span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row justify-content-center">
                            <div className="col-md-7 my-2">
                                <label>
                                    Select Status
                                    <Select
                                        options={statusSelect}
                                        placeholder={'Select Option'}
                                        onChange={handleStatusSelect}
                                        name={'status'}
                                    />
                                    {Object.entries(errMsg).map(([key, val]) => (
                                        <small
                                            className="text-danger validation-error-message"
                                            key={key}>{key == 'status' ? val : ''}
                                        </small>
                                    ))}
                                </label>
                            </div>
                            <div className="col-md-7 my-2">
                                <div className="d-grid">
                                    <button className={'btn btn-success'} onClick={updateStatus}>Update Status</button>
                                </div>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>


            </main>
        </>

    )
}
export default AppointmentList
